// extracted by mini-css-extract-plugin
module.exports = {"formControl":"FormSelect_formControl__2zIRQ","input":"FormSelect_input__fYvAD"};